import {Component} from '@angular/core';
/**
 * \@title Inputs in a form
 */
export class InputFormExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'input-form-example',
  templateUrl: 'input-form-example.html',
  styleUrls: ['input-form-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function InputFormExample_tsickle_Closure_declarations() {
/** @type {?} */
InputFormExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputFormExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
